import React, { useEffect, useState } from "react";
import { FaRocket, FaTimesCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const ActiveNotificationBanner = ({ notification, onClose }) => {
  const [visible, setVisible] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      if (onClose) onClose();
    }, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const handleClick = () => {
    if (notification.projectId && notification.type === "project_created") {
      navigate(`/projects/${notification.projectId}/admin-view`);
    }
  };

  if (!visible || !notification) return null;

  return (
    <div
      onClick={handleClick}
      className="fixed top-5 left-1/2 transform -translate-x-1/2 bg-white px-5 py-3 rounded-md shadow-lg flex items-center gap-3 cursor-pointer z-[9999] max-w-[90vw] font-medium transition-opacity"
    >
      <div className="text-lg">
        {notification.type === "project_created" ? (
          <FaRocket className="text-blue-600" />
        ) : (
          <FaTimesCircle className="text-red-500" />
        )}
      </div>
      <span className="text-sm text-gray-800">{notification.message}</span>
    </div>
  );
};

export default ActiveNotificationBanner;
